<div
  class="message"
  [class.secondary]="useSecondaryColor"
  [ngSwitch]="type"
  [style]="type===2 ? 'white-space: nowrap;' : ''"
>
  <a
    class="message-text"
    [href]="href"
    target="_blank"
    [class.default]="!href"
    [class.animated]="type == 2"
    [ngStyle]="{'--animation-duration': velocity + 's'}"
    [style]="type!=2 ? 'width:100%' : ''"
    style="transform: translateX(0);"
  >

    <ng-container *ngSwitchCase="1">
      <div class="container">
        <span>{{ text }}</span>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="2">
      <span *ngFor="let i of repeatedArray">{{ text }}</span>
    </ng-container>

    <ng-container *ngSwitchCase="3">
      <div class="container">
        <span *ngIf="text">{{ text }}</span>
        <app-countdown-timer
          [endDate]="extra"
        >
        </app-countdown-timer>
        <!-- Temporizador -->
      </div>
    </ng-container>

    <ng-container *ngSwitchDefault>
      <span>{{ text }}</span>
    </ng-container>

  </a>
  <a
      class="message-text"
      [href]="href"
      target="_blank"
      [class.default]="!href"
      [class.animated]="type == 2"
      [ngStyle]="{'--animation-duration': velocity + 's'}"
  >
    <ng-container *ngSwitchCase="2">
      <span *ngFor="let i of repeatedArray">{{ text }}</span>
    </ng-container>
  </a>
</div>
<div #containerRef class="mensaje-container">
  <span #sampleText class="hidden-text">{{ text }}</span>
</div>